import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEgypt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_143)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1739 10.6957H13.0435C13.0435 10.1194 12.5763 9.65218 12 9.65218C11.4237 9.65218 10.9565 10.1194 10.9565 10.6957H7.82605C7.82605 11.272 8.32803 11.7391 8.90431 11.7391H8.86953C8.86953 12.3155 9.33669 12.7826 9.91302 12.7826C9.91302 13.359 10.3802 13.8261 10.9565 13.8261H13.0435C13.6198 13.8261 14.087 13.359 14.087 12.7826C14.6633 12.7826 15.1304 12.3155 15.1304 11.7391H15.0957C15.672 11.7391 16.1739 11.272 16.1739 10.6957Z",
				fill: "#FF9811"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_143",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgEgypt;
